<style>
.message {
    padding: 10px;
    background-color: ghostwhite;
    border: 1px solid lightblue;
    border-radius: 5px;
}

input {
    min-width: 250px;
}

.holder {
    padding-bottom: 40px;
    font-size: 14px;
}

#sign2 {
    margin-top: 15px;
    margin-bottom: 15px;
}
</style>

<script>
import {gapi} from 'gapi-script';
import { getContext, onMount } from 'svelte';
import {push, pop, replace} from './pt-router/Router.svelte'
import * as Common from './Common.js'
import FirstLoginView from './FirstLoginView.svelte'

const { open } = getContext('simple-modal');

export let message;
export let afterFunc
let afterFuncStored

let loginEmail = "";
let loginPassword = "";
let loginContext;

let signUpName = ''
let signUpEmail = ''
let signUpOccupation = ''
let signUpPassword1 = ''
let signUpType = 0;

const { close } = getContext('simple-modal');

window.onGoogleSignIn = (googleUser) => {
    var id_token = googleUser.getAuthResponse().id_token;

    Common.postData('googlesignin', {token: id_token})
    .then(r => {
        if(!r.ok) {
            if (r.code == 406) {
                alert("Email is associated with Email-based account!")
            } else {
                alert("Could not authenticate")
            }
            return
        }

        Common.CreateNotification({body: "Welcome Back to Plan Together!"}, 1000)
        if(r.data == 'first-login') {
            setTimeout(() => {
                open(FirstLoginView, {}, {content: { fontSize: '14px', lineHeight: '1.5em'}});
            }, 100)
        }
        Common.resetCurrentUserValue()
        if(afterFuncStored) {
            afterFuncStored()
            close()
        }
    })
}

onMount(async () => {
    console.log(afterFunc)
    if(afterFunc) {
        afterFuncStored = afterFunc
    } else {
        afterFuncStored = () => {
            if(loginContext) {
                push("/" + loginContext)
                Common.loginContext.update(v => false)
            } else {
                push('/')
            }
        }
    }

    if(Common.currentUserValue) {
        push('/')
        return
    }

    gapi.signin2.render('sign2', {
    'longtitle': true,
    'theme': 'dark',
    'onsuccess': (g) => window.onGoogleSignIn(g)
    });    
})

function submitLogin() {
    let loginRequest = {
        user_email: loginEmail,
        user_password: loginPassword
    }
    Common.postData('session', loginRequest)
    .then(r => {
        if(!r.ok) {
            alert("Incorrect Username or Password. Please try again!")
            return
        }

        Common.CreateNotification({body: "Welcome Back to Plan Together!"}, 1000)
        Common.resetCurrentUserValue()
        if(afterFuncStored) {
            afterFuncStored()
            close()
        }
    })
}

const unsubsribe = Common.loginContext.subscribe(value => {
    loginContext = value
})

function submitSignUp() {
    let signUpRequest = {
        user_name: signUpName,
        user_email: signUpEmail,
        user_occupation: signUpOccupation,
        user_password: signUpPassword1
    }
    Common.postData('user', signUpRequest)
    .then(r => {
        if(!r.ok) {
            if(r.code == 406) {
                alert("Username taken.")
            } else if(r.code == 400) {
                alert("Email already associated with another account.")
            } else {
                alert("Problem signing up, please try again")
            }
            return
        }

        loginEmail = signUpRequest.user_email
        loginPassword = signUpRequest.user_password
        
        let afterFuncOriginal = afterFuncStored
        afterFuncStored = () => {
            if(afterFuncOriginal) {
                afterFuncOriginal()
            }
            setTimeout(() => {
                close()
                open(FirstLoginView, {}, {content: { fontSize: '14px', lineHeight: '1.5em'}});
            }, 1000)
        }
        submitLogin()

    })
    .catch(data => {
        alert("Could not create user!")
    })
}
</script>

<div class="holder">
{#if message}
    <div class="message">
        {message}
    </div>
{/if}
    <h1>Sign In</h1>
    <strong>With Google:</strong><div id="sign2"></div>
    <strong>With Email:</strong>
    <p>
        <a href="#/forgot-password">Forgot password?</a>
    </p>
    <div>
        <input type="email" placeholder="Email Address" bind:value={loginEmail}><br>
        <input type="password" placeholder="Password" bind:value={loginPassword}><br>
        <button on:click={submitLogin}>Login</button>
    </div>
    <br>
    <br>
    <h1>Sign Up</h1>
    <p>
        If you do not have an account yet, it is quick, easy and free to join. Remember, joining means you agree to follow the <a href="#/policies">Community Policies</a>.
    </p>
    <input type="text" placeholder="User Name" bind:value={signUpName}><br>
    <input type="text" placeholder="Who are you? (Optional)" bind:value={signUpOccupation}><br>
    <input type="email" placeholder="Email Address" bind:value={signUpEmail}><br>
    <input type="password" placeholder="Password" bind:value={signUpPassword1}><br>
    <button on:click={submitSignUp}>Sign Up</button>
</div>